import React from 'react';
import {
  TabPanel as VoltaTabPanel,
  TabPanelProps as VoltaTabPanelProps,
} from '@contact/ui-volta';

export type TabPanelProps = VoltaTabPanelProps;

export const TabPanel = (props: TabPanelProps) => <VoltaTabPanel {...props} />;
